import { DEPLOYMENT_URL } from "@shared/constants";
import { Finding, UpdateFindingBody } from "@shared/types";

import { authPut } from "../auth/auth";

export const updateDeploymentFinding = (
  deploymentId: number,
  findingId: number,
  update: UpdateFindingBody
) => {
  return authPut<UpdateFindingBody, Finding>(
    `${DEPLOYMENT_URL}/${deploymentId}/issues/${findingId}`,
    update
  );
};
